import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IAffiliateShowFixedPaymentResponse } from '../types';
import { AFFILIATE_TRACKER_FIXED_PAYMENT_API_URL, AFFILIATE_TRACKER_FIXED_PAYMENT_QUERY } from '../constants';

export default function useShowFixedPaymentQuery(id: Ref<number>, trackerId: Ref<number>): IContextQueryResult<
  IAffiliateShowFixedPaymentResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateShowFixedPaymentResponse>({
    queryKey: [AFFILIATE_TRACKER_FIXED_PAYMENT_QUERY, id, trackerId],
    queryFn: async ({ signal }) => fetchGet<IAffiliateShowFixedPaymentResponse>(
      AFFILIATE_TRACKER_FIXED_PAYMENT_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
        urlParams: {
          id: id.value,
          trackerId: trackerId.value,
        },
      },
    ),
    enabled: computed(() => !!id.value && !!trackerId.value),
  });
}
